export default function SectionSeparator() {
  return (
    <hr className="border-white dark:border-slate-300 my-12 md:my-24 lg:my-32" />
  );
}
